'use client'

import { liveStatus } from '@lib/config'
import { useTranslations } from 'next-intl'
import { useRef, useState } from 'react'
import { useMount, useUnmount } from 'react-use'

export default function LiveCountdown({
  status,
  statusLabel,
  startTime,
}) {
  const ts = useTranslations('live')

  const [now, setNow] = useState(0)
  const intervalRef = useRef(null)

  useMount(() => {
    intervalRef.current = setInterval(() => {
      setNow(Math.floor(Date.now() / 1000))
    }, 1000)
  })
  useUnmount(() => {
    clearInterval(intervalRef.current)
    intervalRef.current = null
  })

  // 直播结束
  if (status === liveStatus.end) return statusLabel
  // 直播中
  if (status === liveStatus.living) return ts('living')
  // 未开始
  if (now === 0) return null
  if (now > startTime) return ts('preparing')

  const res = []
  const diffTime = Math.abs(startTime - now)
  const oneDay = 60 * 60 * 24
  const oneHour = 60 * 60
  const day = Math.floor(diffTime / oneDay)
  const hour = Math.floor((diffTime % oneDay) / oneHour)
  const minute = Math.ceil((diffTime - day * oneDay - hour * oneHour) / 60)
  day && res.push(`${day}${ts('day')}`)
  hour && res.push(`${hour}${ts('hours')}`)
  minute && res.push(`${minute}${ts('minutes')}`)
  return res.join('')
}
